// components/DeploymentLogsDialog.js
import React, { useState, useEffect } from "react";
import { db } from "../../firebase"; // Adjust the import path based on your setup
import { ref, onValue } from "firebase/database";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

function DeploymentLogsDialog({ clientCode, machineName, open, onClose }) {
  const [logs, setLogs] = useState([]);
  const theme = useTheme();

  useEffect(() => {
    if (!clientCode || !machineName || !open) return; // Fetch data only if the dialog is open

    const deploymentLogsRef = ref(
      db,
      `deploymentLogs/${clientCode}/${machineName}`,
    );
    onValue(deploymentLogsRef, (snapshot) => {
      const data = snapshot.val() || {};
      const formattedLogs = [];

      for (const deploymentId in data) {
        const deployment = data[deploymentId];
        const logEntries = deployment.logs || {};

        for (const logId in logEntries) {
          formattedLogs.push({
            id: logId,
            ...logEntries[logId],
            deploymentId,
          });
        }
      }

      // Sort logs by timestamp
      formattedLogs.sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
      );
      setLogs(formattedLogs);
    });
  }, [clientCode, machineName, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default, // Use theme colors
          color: theme.palette.text.primary,
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.success.text,
        }}
      >
        Deployment Logs for {machineName}
      </DialogTitle>
      <DialogContent>
        {logs.length > 0 ? (
          <List>
            {logs.map((log) => (
              <ListItem
                sx={{
                  color: theme.palette.success.text,
                }}
                key={log.id}
                disablePadding
              >
                <ListItemText
                  primary={log.message}
                  secondary={new Date(log.timestamp).toLocaleString()}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography>No logs available for this deployment.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: theme.palette.info.main }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeploymentLogsDialog;
